import axios from "@/plugins/axios";

// Perbelanjaan Isi Rumah Bulanan mengikut Daerah Pentadbiran & Strata (Purata only).
// Expenditure version of daerahXstrata.js. A negeri is required. By default ALL years
// (incl. the latest) come from the precomputed `lampiran_negxdaerahxstrata` (Bandar/Luar
// Bandar) + `negxdaerah` (Jumlah) tables (TW_/W_purata_perbelanjaan cols) so they match
// the official figures; a backend code toggle (LATEST_FROM_HID in getPerbelanjaanPurataLampiran.js)
// switches the latest year to a live `lampiran_hid_perbelanjaan` calculation.
// `data.purata` holds rows of
// { dp, daerah, isTotal, strata:{ Bandar:{y:v}, 'Luar Bandar':{y:v}, Jumlah:{y:v} } }
// (negeri-total row first). `data.penengah` is always [] for this page.
export default class perbelanjaanDaerahStrataServices {
  // params: { NG (required), P (csv pusingan), S ("1"|"2"|"3"), W ("W"|"TW") }
  async getPerbelanjaanDaerahStrata(params = {}) {
    const res = await axios.get(
      `${process.env.VUE_APP_API_URL}/JadualAwalan/getPerbelanjaanDaerahStrataLampiran`,
      { params }
    );
    return (res.data && res.data.data) || {};
  }
}
